import { CLEAR_MEGAMENU_HISTORY } from 'redux/modules/mega-menu/actions/types';

export default () => ({
  type: CLEAR_MEGAMENU_HISTORY,
});
